var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask",style:(_vm.maskStyle)},[(_vm.text)?_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('div',[_vm._v(" #"+_vm._s(_vm.hex)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }